const clampIntersectionThreshold = (value: number) =>
  Math.min(1, Math.max(0, value))

export const sanitizeIntersectionThreshold = (
  threshold: number | number[] | undefined,
  fallback: number = 0
): number | number[] => {
  if (Array.isArray(threshold)) {
    const sanitized = threshold
      .filter((value) => Number.isFinite(value))
      .map((value) => clampIntersectionThreshold(value))

    return sanitized.length > 0
      ? sanitized
      : clampIntersectionThreshold(fallback)
  }

  if (threshold == null || !Number.isFinite(threshold)) {
    return clampIntersectionThreshold(fallback)
  }

  return clampIntersectionThreshold(threshold)
}
